import script from "./UserManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./UserManagement.vue?vue&type=script&setup=true&lang=js"

import "./UserManagement.vue?vue&type=style&index=0&id=33d4c80f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33d4c80f"]])

export default __exports__